import { render, staticRenderFns } from "./BaseBlock.vue?vue&type=template&id=724d3c66&scoped=true"
import script from "./BaseBlock.vue?vue&type=script&lang=js"
export * from "./BaseBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseBlock.vue?vue&type=style&index=0&id=724d3c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724d3c66",
  null
  
)

export default component.exports